module.exports = __webpack_public_path__ + "static/media/design_flow.55922441.png";